import React from "react";
import styled from "styled-components";
import useProductName from "brand-customization/useProductName";
import { useConfiguration } from "forwarder/wizard/select-forwarder-step/hooks/useConfiguration";
import { Button, Panel } from "components/bootstrap";
import { ClipboardButton, Icon } from "components/common";
import AppConfig from "util/AppConfig";
import ForwarderInputInformation from "forwarder/wizard/select-forwarder-step/start-new-forwarder-steps/ForwarderInputInformation";
import useForwardersConfiguration from "forwarder/wizard/select-forwarder-step/hooks/useForwardersConfiguration";
const StyledConfigurationPanel = styled(Panel)`
  font-size: 1.1em;
  margin: 20px;
  padding: 20px;
  border-color: ${(props) => props.theme.colors.input.border};

  dd {
    border-bottom: 1px solid ${(props) => props.theme.colors.gray[90]};
    font-size: 1.2em;
    margin-bottom: 5px;
  }
`;
const CenteredContent = styled.div`
  margin: 0 auto;
  text-align: center;
`;
const StyledCopyButtonTitle = styled.span`
  font-size: 1.2em;
`;
const StyledIcon = styled(Icon)`
  margin-right: 0.5em;
`;
const StyledButton = styled(Button)`
  margin-top: 20px;
`;
const ForwarderConfigurationOptions = ({
  forwarderInput = void 0,
  token = void 0
}) => {
  const [configuration] = useConfiguration(forwarderInput);
  const { data: forwarderConfiguration } = useForwardersConfiguration();
  if (!AppConfig.isCloud() && !(forwarderConfiguration == null ? void 0 : forwarderConfiguration.forwarder_service_autostart) && !forwarderInput) {
    return null;
  }
  const ButtonTitle = /* @__PURE__ */ React.createElement(StyledCopyButtonTitle, null, /* @__PURE__ */ React.createElement(StyledIcon, { name: "content_copy" }), " Copy as configuration snippet");
  const clipboardContent = Object.entries(configuration).map(([key, value]) => {
    const effectiveValue = key === "forwarder_grpc_api_token" && token ? token.token : String(value);
    return `${key} = ${effectiveValue}`;
  }).join("\n");
  return /* @__PURE__ */ React.createElement(StyledConfigurationPanel, null, /* @__PURE__ */ React.createElement("dl", null, Object.entries(configuration).map(([key, value]) => /* @__PURE__ */ React.createElement(React.Fragment, { key }, /* @__PURE__ */ React.createElement("dt", null, key), /* @__PURE__ */ React.createElement("dd", null, key === "forwarder_grpc_api_token" && token ? token.token : String(value))))), /* @__PURE__ */ React.createElement(CenteredContent, null, /* @__PURE__ */ React.createElement(ClipboardButton, { title: ButtonTitle, text: clipboardContent, bsStyle: "info" })));
};
const ConfigureNewForwarderStep = ({
  eventKey,
  token = void 0,
  forwarderInputs = void 0,
  onStepComplete
}) => {
  const productName = useProductName();
  return /* @__PURE__ */ React.createElement(Panel, { eventKey }, /* @__PURE__ */ React.createElement(Panel.Heading, null, /* @__PURE__ */ React.createElement(Panel.Title, null, /* @__PURE__ */ React.createElement(Panel.Toggle, { tabIndex: 0 }, "3. Configure Forwarder"))), /* @__PURE__ */ React.createElement(Panel.Body, { collapsible: true }, /* @__PURE__ */ React.createElement("p", null, "Once ", productName, " Forwarder is installed, add the following configuration options in order to connect to this", " ", productName, " instance."), /* @__PURE__ */ React.createElement(ForwarderInputInformation, { forwarderInputs }), /* @__PURE__ */ React.createElement(ForwarderConfigurationOptions, { forwarderInput: forwarderInputs == null ? void 0 : forwarderInputs[0], token }), /* @__PURE__ */ React.createElement(StyledButton, { bsStyle: "primary", bsSize: "sm", onClick: onStepComplete }, "Continue")));
};
export default ConfigureNewForwarderStep;
